import { render, staticRenderFns } from "./chapterForm.vue?vue&type=template&id=0c674284&scoped=true&"
import script from "./chapterForm.vue?vue&type=script&lang=js&"
export * from "./chapterForm.vue?vue&type=script&lang=js&"
import style0 from "./chapterForm.vue?vue&type=style&index=0&id=0c674284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c674284",
  null
  
)

export default component.exports